import "./i18n";

import "./Steps.scss";
import { useTranslation } from "react-i18next";
import { RoundedCard } from "components/RoundedCard/RoundedCard";
import mobile from "../../../../assets/rounded-logos/mobile.svg";
import clock from "../../../../assets/rounded-logos/clock.svg";
import walet from "../../../../assets/rounded-logos/walet.svg";
import Title from "components/Title/Title";
import Reveal from "components/Reveal/Reveal";

export const Steps = () => {
  const { t } = useTranslation();
  const Cards = [
    { img: mobile, label: "steps:first" },
    { img: clock, label: "steps:second" },
    { img: walet, label: "steps:third" },
  ];
  return (
    <div className="step-section">
      <div className="step-background" />
      <div className="step-container">
      <Title title={t("steps:title")} color="white" />
      <div className="step-container-row">
        <div className="step-container-col-xs-6 step-container-col-sm-3  step-container-col-md-2   step-container-col-6">
          <Reveal>
          <RoundedCard
            img={Cards[0].img}
            label={t(Cards[0].label)}
          />
          </Reveal>
        </div>
        <div className="step-container-col-xs-6 step-container-col-sm-3  step-container-col-md-2   step-container-col-6">
        <Reveal delay={150}>
          <RoundedCard
            img={Cards[1].img}
            label={t(Cards[1].label)}
          />
          </Reveal>
        </div>
        <div className="step-container-col-xs-6 step-container-col-sm-6  step-container-col-md-2   step-container-col-6">
          <Reveal delay={300}>
          <RoundedCard
            img={Cards[2].img}
            label={t(Cards[2].label)}
          />
          </Reveal>
          
        </div>
      </div>
    </div>
    <div className="step-background-shadow" />
    </div>
  );
};
